function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getDefaultConfig } from '../../tinyMceConfig';
import { useSelector } from 'react-redux';
import { Modal } from '../..';
import { Card } from 'react-bootstrap';
import OnlyCommentsEditor from '../OnlyCommentsEditor';
import ReviewableFieldEditorWithAutomaticUpdates from '../ReviewableFieldEditorWithAutomaticUpdates';
import claimGroupService from '../../../services/claim_group.service';
import claimProjectReportService from '../../../services/project_report/claim_project_report.service';
import { useErrorHandling } from '../../../hooks/useErrorHandling';
import { Loader } from '../../Loader';
export default function EditProjectReportNameModal(_ref) {
  let {
    claimGroupId,
    projectReportId,
    isVisible,
    isUnderReview,
    footnoteStartIndex
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [claimProjetcReport, setClaimProjectReport] = useState(null);
  const [claimGroup, setClaimGroup] = claimGroupService.useGetClaimGroup(claimGroupId);
  const [closeButtonLoading, setCloseButtonLoading] = useState(false);
  const dataEditObjectProps = {
    modelClass: 'ClaimProjectReport',
    modelId: projectReportId,
    modelField: 'project_name'
  };
  const fetchData = useErrorHandling(useCallback(async () => {
    const projectReport = await claimProjectReportService.get(claimGroupId, projectReportId);
    setClaimProjectReport(projectReport);
  }, [claimGroupId, projectReportId]));
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const updateProjectReportNameFn = claimProjectReportService.useUpdateClaimProjectReportName(claimGroupId, claimProjetcReport, true);
  const getContentFn = useCallback(async () => {
    const projectReport = await claimProjectReportService.get(claimGroupId, projectReportId);
    setClaimProjectReport(projectReport);
    return projectReport.project_name_html;
  }, [claimGroupId, projectReportId]);
  const onUpdateContentFn = useCallback(() => {
    setCloseButtonLoading(false);
  }, []);
  const editorInitConfig = useMemo(() => {
    if (!claimProjetcReport) {
      return {};
    }
    return getDefaultConfig({
      footnoteStartIndex,
      modules: {
        styles_formatter: false
      }
    });
  }, [claimProjetcReport, footnoteStartIndex]);
  const trackChangesEditorInitFn = useCallback(addCommentCallback => {
    if (!claimProjetcReport) {
      return {};
    }
    const editorModuleOptions = {
      isTrackingChanges: true,
      onAddCommentButtonClickCallback: addCommentCallback,
      showTrackChangesControls: true,
      footnoteStartIndex,
      modules: {
        styles_formatter: false
      }
    };
    return getDefaultConfig(editorModuleOptions);
  }, [claimProjetcReport, footnoteStartIndex]);
  const onTrackChangesCreateComment = useCallback(() => {
    setCloseButtonLoading(true);
  }, []);
  const onEditorChange = useCallback(() => {
    setCloseButtonLoading(true);
  }, []);
  const editProjectReportNameModalBody = () => {
    if (!claimProjetcReport || !claimGroup) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, user.account_type === 'customer' && !claimGroup.active_change_set?.finalized_at && /*#__PURE__*/React.createElement(OnlyCommentsEditor, _extends({
      getContentFn: getContentFn,
      updateContentFn: updateProjectReportNameFn
    }, dataEditObjectProps)), user.account_type === 'customer' && !!claimGroup.active_change_set?.finalized_at && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: claimProjetcReport.project_name_html
      }
    }), user.account_type !== 'customer' && /*#__PURE__*/React.createElement(ReviewableFieldEditorWithAutomaticUpdates, _extends({
      isUnderReview: isUnderReview
    }, dataEditObjectProps, {
      getContentFn: getContentFn,
      updateContentFn: updateProjectReportNameFn,
      onUpdateContentFn: onUpdateContentFn,
      editorInitConfig: editorInitConfig,
      trackChangesOnCreateComment: onTrackChangesCreateComment,
      trackChangesEditoInitFn: trackChangesEditorInitFn,
      onEditorChange: onEditorChange,
      showTrackChangesControls: true
    }))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: `Edit project report title`,
    show: isVisible,
    renderBody: editProjectReportNameModalBody,
    onHide: () => window.location.reload(),
    closeButtonLoading: closeButtonLoading,
    disabled: closeButtonLoading,
    closeText: "Save"
  });
}